// src/components/PermissionGate.js
import React from "react";
import { usePermission } from "../../../hooks/usePermissions";

export function PermissionGate({ actionKey, children }) {
  const { hidden, disabled } = usePermission(actionKey);

  if (hidden) return null;

  const child = React.Children.only(children);

  // Gestion des styles pour rendre le bouton "grisé"
  const originalStyle = child.props.style || {};
  const newStyle = {
    ...originalStyle,
    pointerEvents: disabled ? "none" : undefined,
    opacity: disabled ? 0.5 : undefined,
    cursor: disabled ? "not-allowed" : originalStyle.cursor,
  };

  return React.cloneElement(child, {
    ...child.props,
    disabled: disabled || child.props.disabled,
    onClick: disabled ? undefined : child.props.onClick,
    style: newStyle,
  });
}
